import { FC } from 'react'
import { Logo } from '../general/navigation/logo'
import { DOMAIN_NAME, companyName } from '@app/configs'
import { Link } from '@app/components/stateless/typo/link'
import { getNavbarStyles } from '../general/navigation/styles'
import { TranslateLanguageLink } from '../general/navigation/translate-link'
import { SkipContent } from '../general'
import { useTranslation } from '@app/lib/hooks/useTranslation'

export const NavBar: FC<{
  title?: string
  baseRoute?: string
  podcast?: boolean
}> = ({ title, baseRoute }) => {
  const { t } = useTranslation('common')

  return (
    <header>
      <SkipContent />
      <div className='min-h-[55px] px-3 py-1 flex place-items-center md:py-3'>
        <nav className={getNavbarStyles({})}>
          <div className='relative flex items-center min-h-[inherit] space-x-1'>
            <Link
              href={`${DOMAIN_NAME}/`}
              className={'hover:ring-4 rounded'}
              shouldPrefetch={false}
            >
              <Logo t={t} />
            </Link>
            <span className='text-black dark:text-white text-xl'>/</span>
            <Link
              href={`${DOMAIN_NAME}/${baseRoute ?? 'blog'}`}
              className={
                'md:text-xl text-black dark:text-white hover:text-blue-600 dark:hover:text-blue-400'
              }
            >
              {title ?? companyName}
            </Link>
          </div>
        </nav>
        <TranslateLanguageLink className='pl-3' />
      </div>
    </header>
  )
}
